import React, { useState } from "react";
import DeleteImg from "../../assets/delLogo.png";
import verifyImg from "../../assets/verifyImg.png";
import InfoCard from "../../components/card/infocard";
import {
  DeleteItem,
  InviteModal,
  SuccessfulDelete,
  SuccessModal,
} from "../../components/modal";
import { SimpleButton } from "../../components/button.jsx/Btn";
import { useNavigate } from "react-router-dom";
import PageIntroNav from "../../components/navigation/PageIntroNav";

const CompanyViewDetails = () => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openSuccessfulDeleteModal, setOpenSuccessfulDeleteModal] =
    useState(false);
  const [openlevelModal, setOpenLevelModal] = useState(false);
  const [opensucesssModal, setOpensuccessModal] = useState(false);

  const openModal = () => setOpenLevelModal(true);

  let navigate = useNavigate();

  const openDeleteLevel = () => setOpenDeleteModal(true);
  const cancelDeleteModal = () => setOpenDeleteModal(false);

  const confirmDeleteDepartment = () => {
    setOpenDeleteModal(false);
    setOpenSuccessfulDeleteModal(true);
  };

  const createHandleSuccess = (ev) => {
    ev.preventDefault();
    setOpenLevelModal(false);
    setOpensuccessModal(true);
  };
  return (
    <div className=" font-Outfit">
      <PageIntroNav
        breadcrumbs={[
          { label: "Company Settings", path: "/company-settings" },
          { label: "Company", path: "/company-settings/company" },
          { label: "Company Details" },
        ]}
        title="Company Details"
        subtitle="Company profile and management actions."
        fallbackPath="/company-settings/company"
        backLabel="Back to Company"
        actions={(
          <div className="flex items-center gap-3">
            <button
              onClick={openModal}
              className="border border-[#1234CD] text-[#1234CD] px-4 py-2 rounded-xl"
            >
              Edit
            </button>
            <button
              onClick={openDeleteLevel}
              className="border border-red-500 text-red-600 px-4 py-2 rounded-xl"
            >
              Delete
            </button>
          </div>
        )}
      />

      <InfoCard
        details="Position Details"
        title="CEPHAS ICT HUB NIGERIA LIMITED"
        description="Lorem ipsum dolor sit amet consectetur. Tellus ut integer velit egestas mi pretium eu odio. Fames tellus consectetur urna sit euismod ipsum egestas in. Vulputate eget tortor risus sit. Pharetra mi tincidunt amet donec vitae ornare. Rhoncus lectus amet in risus consequat malesuada et. Sed et dolor quam lacus aenean sociis. Ullamcorper laoreet et ipsum ut eget. Ut amet purus lobortis tellus neque imperdiet. Tempus sagittis adipiscing amet sagittis ac.
"
        metaData={[{ label: "Date created", value: "11th April, 2024" }]}
        // image={HOD}
      >
        {/* <div className="flex gap-2">
          <button>Delete level</button>
          <button className="px-4 py-2 rounded bg-blue-700 text-white">
            Update
          </button>
        </div> */}
      </InfoCard>

      <DeleteItem
        isOpen={openDeleteModal}
        onClose={cancelDeleteModal}
      >
        <div>
          <img
            className=" w-40 mx-auto animate-pulse"
            src={DeleteImg}
            alt="verify del"
          />

          <h1 className="text-lg text-center text-[#000000] font-bold">
            Continue to delete `ITEM`
          </h1>
          <p className="text-sm text-center mt-2">Action cannot be undone</p>
        </div>
        <div className="flex items-center py-4 gap-4 my-4">
          <button
            onClick={cancelDeleteModal}
            className=" border-[#1233CC] py-1 border-2 text-[#1233CC] font-medium px-4 rounded-[10px] w-[102px]"
          >
            No
          </button>
          <button
            className="text-[16px] font-medium px-4 py-1 bg-[#1233CC] rounded-[10px] w-[102px] text-white"
            onClick={confirmDeleteDepartment}
          >
            Yes
          </button>
        </div>
      </DeleteItem>

      <SuccessfulDelete
        isOpen={openSuccessfulDeleteModal}
        onClose={() => setOpenSuccessfulDeleteModal(false)}
      >
        <div>
          <img
            src={verifyImg}
            alt=" verify delete"
            className=" w-20 animate-ping mx-auto"
          />
          <div className=" text-center mt-6">
            <h2 className="text-black text-[20px] leading-[27px] font-bold mb-2">
              "Item Type'
            </h2>
            <p className="text-[#74777B] text-[14px] leading-[18.9px]">
              deleted successfully!
            </p>
          </div>
        </div>
      </SuccessfulDelete>

      <InviteModal
        isOpen={openlevelModal}
        onClose={() => setOpenLevelModal(false)}
      >
        <div className="my-8">
          <div>
            <p className=" text-2xl font-semibold text-black font-Outfit">
              Edit Company
            </p>
          </div>
          <form
            className="my-12"
            onSubmit={(e) => e.preventDefault()}
          >
            <div>
              <label
                htmlFor="invite-email"
                className="block mb-2 font-[500] text-[14px] text-black leading-[18.9px] font-satosh"
              >
                Company Name
              </label>
              <input
                type="text"
                id="text"
                placeholder="Title"
                // value={inviteEmail}
                // onChange={(ev) => setInviteEmail(ev.target.value)}
                className="w-full p-2 text-center mb-2  rounded-xl focus:outline-[#1234CD] border-2 border-[#F3F5F5] py-[16px]"
              />
            </div>

            <div>
              <label
                htmlFor="invite-email"
                className="block mb-2 font-[500] text-[14px] text-black leading-[18.9px] font-satosh"
              >
                Company Website
              </label>
              <input
                type="text"
                id="text"
                placeholder="Title"
                // value={inviteEmail}
                // onChange={(ev) => setInviteEmail(ev.target.value)}
                className="w-full p-2 text-center mb-2  rounded-xl focus:outline-[#1234CD] border-2 border-[#F3F5F5] py-[16px]"
              />
            </div>

            <div className=" flex justify-center gap-12 mt-20 items-end">
              <SimpleButton
                onClick={() => navigate("/company-settings/company")}
                type="submit"
                className="font-[700] font-satoshi  leading-[21.6px] flex justify-center items-center border w-40 rounded-xl  py-[16px] border-[#1234CD] text-[#1234CD] text-[16px] "
              >
                Cancel
              </SimpleButton>

              <SimpleButton
                onClick={createHandleSuccess}
                type="submit"
                className="font-[700] font-satoshi  leading-[21.6px] flex justify-center items-center w-40 rounded-xl text-white py-[16px] bg-[#1234CD] text-[16px] "
              >
                <span>Update</span>
              </SimpleButton>
            </div>
          </form>
        </div>
      </InviteModal>

      <SuccessModal
        isOpen={opensucesssModal}
        onClose={() => setOpensuccessModal(false)}
      />
    </div>
  );
};

export default CompanyViewDetails;
